'use client';

interface SuspendedModalProps {
  message: string;
  onClose?: () => void;
}

export default function SuspendedModal({ message, onClose }: SuspendedModalProps) {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 px-4">
      <div className="bg-white rounded-[20px] p-8 max-w-md w-full shadow-2xl animate-fadeIn">
        <div className="text-center">
          {/* Icon */}
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-4">
            <svg className="h-8 w-8 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>

          {/* Title */}
          <h3 className="font-['Gotham_Rounded',sans-serif] text-[24px] font-bold text-[#2E2A3A] mb-2">
            Account Suspended
          </h3>

          {/* Message */}
          <p className="font-['Archivo',sans-serif] text-[16px] text-[#6e6672] mb-6">
            {message}
          </p>

          {/* Info */}
          <div className="bg-[#F6EFED] rounded-[12px] p-4 mb-6">
            <p className="font-['Archivo',sans-serif] text-[14px] text-[#2E2A3A]">
              You will be redirected to the login page in a few seconds...
            </p>
          </div>

          {/* Loading indicator */}
          <div className="flex justify-center">
            <div className="w-8 h-8 border-4 border-[#8a7490] border-t-transparent rounded-full animate-spin"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
